<template>
  <div class="template-flexible-steps">
    <div class="content pb-5 pt-3">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <MaterialHeader :content="content"/>
            <h2 class="text-primary bold mb-2 material-title"
                v-html="content.title.rendered"></h2>
            <p class="material-subtitle text-secondary">{{content.acf.subtitle}}</p>
            <div class="introduction mb-5 pt-3" v-if="content.acf.introduction.text">
              <div class="d-flex justify-content-start align-items-start align-items-md-center">
                <img v-if="content.acf.introduction.icon" :src="content.acf.introduction.icon" class="icon">
                <div class="m-0" v-html="content.acf.introduction.text"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <div class="steps">
            <div v-for="(step, i) in content.acf.steps" :key="`step-${i}`" class="step">
              <div class="row">
                <div class="col-12">
                  <h3 class="pointer d-flex justify-content-between align-items-center"
                      v-b-toggle="`collapse-step-${i}`">
                    <span class="step-title">
                      <span class="text-secondary mr-3">{{formatStepNumber(i)}}</span>
                      <span>
                        <span class="bold">{{step.step_pretitle}}</span> {{step.step_title}}
                      </span>
                    </span>
                    <span :class="{'d-none': documentGenerating}">
                      <img src="@/assets/icons/plus-secondary-thin.svg" class="img-fluid when-closed">
                      <img src="@/assets/icons/arrow-primary.svg" class="img-fluid when-open">
                    </span>
                  </h3>
                  <b-collapse :id="`collapse-step-${i}`" :visible="documentGenerating">
                    <div class="step-content mt-2">
                      <div v-for="(element, j) in step.step_content" :key="`step-content-${i}-${j}`">
                        <!-- Text -->
                        <div v-if="element.acf_fc_layout === 'step_content_text'"
                             v-html="element.text"></div>
                        <!-- Dropdown -->
                        <div v-if="element.acf_fc_layout === 'dropdown'" class="dropdown">
                          <h4 class="bold" v-b-toggle="`step-dropdown-${i}-${j}`">
                            <span class="heading">
                              <span class="text-secondary">{{element.pretitle}}</span> {{element.title}}
                            </span>
                            <span :class="{'d-none': documentGenerating}" class="dropdown-icon">
                              <img src="@/assets/icons/plus-secondary-thin.svg" class="img-fluid when-closed">
                              <img src="@/assets/icons/arrow-primary.svg" class="img-fluid when-open">
                            </span>
                          </h4>
                          <b-collapse :id="`step-dropdown-${i}-${j}`" :visible="documentGenerating">
                            <div v-html="element.text" class="pb-2"></div>
                          </b-collapse>
                        </div>
                        <!-- Gallery -->
                        <div v-if="element.acf_fc_layout === 'gallery'">
                          <Gallery :images="element.gallery"/>
                        </div>
                        <!-- Text with icon on the left -->
                        <div v-if="element.acf_fc_layout === 'text_with_icon_on_the_left'"
                             class="text-with-icon-left">
                          <div class="icon">
                            <img :src="element.icon">
                          </div>
                          <div v-html="element.text"></div>
                        </div>
                        <div v-if="element.acf_fc_layout === 'multiple_icons_on_the_left_with_text'"
                             class="mb-2">
                          <div v-for="(section, k) in element.section" :key="k"
                               class="multi-icons-with-text d-flex mb-1">
                            <div class="icons">
                              <div v-for="(icon, l) in section.icons" :key="l" class="mb-2 mr-4">
                                <img :src="icon.icon"/>
                              </div>
                            </div>
                            <div v-html="section.text" class="text-content"></div>
                          </div>
                        </div>
                        <div v-if="element.acf_fc_layout === 'table_extended'"
                             class="mb-2">
                          <TableExtended :tableContents='element.table_content'/>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MaterialHeader from '@/templates/template-parts/MaterialHeader.vue';
import Gallery from '@/templates/template-parts/Gallery.vue';
import TableExtended from '@/templates/template-parts/TableExtended.vue';

export default {
  props: {
    content: Object,
    documentGenerating: null,
  },
  components: {
    MaterialHeader,
    Gallery,
    TableExtended,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.material-subtitle {
  font-size: 25px;
}
@include media-breakpoint-down(lg) {
  .material-title {
    font-size: 24px;
  }
  .material-subtitle {
    font-size: 20px;
  }
}
.introduction {
  img {
    width: 100%;
    max-width: 65px;
    margin-right: 25px;
  }
}
.introduction,
.text-before-steps {
  font-size: 16px;
}

.steps {
  .step {
    &:first-of-type {
      border-top: 1px solid $secondary;
    }
    border-bottom: 1px solid $secondary;
    h3 {
      font-size: 20px;
      margin: 0;
      padding: .9em 0 .9rem .5rem;
      .step-title {
        display: flex;
      }
      img {
        width: 15px;
        margin: 0 10px 0 10px;
      }
      &:focus {
        outline: 0;
      }
      img.when-open {
        transform: rotate(-90deg);
      }
      &.collapsed img.when-open,
      &.not-collapsed img.when-closed {
        display: none;
      }
    }
    .step-content {
      padding: 0 55px 20px 46px;
      @include media-breakpoint-down(sm) {
        padding: 0 0 10px 0;
      }
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }
    }
    .step-pictures {
      display: flex;
      flex-wrap: wrap;
      > div {
        max-width: 30%;
        width: 100%;
        padding: 10px;
        @include media-breakpoint-down(sm) {
          max-width: 50%;
        }
        img {
          transition: all .3s ease-in-out;
          background: white;
          max-height: 200px;
        }
      }
      .picture {
        max-width: 200px;
        width: 100%;
        height: 200px;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        transition: all .3s ease-in-out;
        background-color: white;
        &:hover {
          transform: scale(1.5);
          box-shadow: 0px 0px 0px 1px #e0e0e0;
        }
        @include media-breakpoint-down(sm) {
          height: 100px;
          max-width: 100px;
        }
      }
      .picture-caption {
        text-align: center;
        font-size: 14px;
      }
    }
  }
}
.dropdown {
  h4 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    .heading {
      padding-right: 10px;
    }
    .dropdown-icon {
      width: 100%;
      max-width: 15px;
    }
    img {
      width: 100%;
    }
    img.when-open {
      transform: rotate(-90deg);
    }
    &.collapsed img.when-open,
    &.not-collapsed img.when-closed {
      display: none;
    }
    &:focus {
      outline: 0;
    }
  }
}
.text-with-icon-left {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: .5rem;
  .icon {
    margin-right: 30px;
    max-width: 70px!important;
    width: 100%;
    img {
      width: 100%;
    }
  }
  @include media-breakpoint-down(sm) {
    .icon {
      margin-right: 10px;
      max-width: 50px!important;
    }
  }
}
::v-deep ul {
  @extend .list-square;
}

.multi-icons-with-text {
  .icons {
    max-width: 80px;
    width: 100%;
    flex: 2;
    img {
      max-width: 80px;
    }
    @include media-breakpoint-down(sm) {
      max-width: 60px;
      img {
        max-width: 60px;
      }
    }
  }
  .text-content {
    flex: 1;
  }
}
</style>
